import { render, staticRenderFns } from "./ProductionModel.vue?vue&type=template&id=0d74c50c&scoped=true"
import script from "./ProductionModel.vue?vue&type=script&lang=js"
export * from "./ProductionModel.vue?vue&type=script&lang=js"
import style0 from "./ProductionModel.vue?vue&type=style&index=0&id=0d74c50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74c50c",
  null
  
)

export default component.exports